/*!
 * devextreme-angular
 * Version: 16.2.5
 * Build date: Tue Feb 28 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = require('@angular/core');
var nested_option_1 = require('../../core/nested-option');
var nested_option_2 = require('../../core/nested-option');
var DxiLegendComponent = (function (_super) {
    __extends(DxiLegendComponent, _super);
    function DxiLegendComponent(parentOptionHost, optionHost) {
        _super.call(this);
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    Object.defineProperty(DxiLegendComponent.prototype, "backgroundColor", {
        get: function () {
            return this._getOption('backgroundColor');
        },
        set: function (value) {
            this._setOption('backgroundColor', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "border", {
        get: function () {
            return this._getOption('border');
        },
        set: function (value) {
            this._setOption('border', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "columnCount", {
        get: function () {
            return this._getOption('columnCount');
        },
        set: function (value) {
            this._setOption('columnCount', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "columnItemSpacing", {
        get: function () {
            return this._getOption('columnItemSpacing');
        },
        set: function (value) {
            this._setOption('columnItemSpacing', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "customizeHint", {
        get: function () {
            return this._getOption('customizeHint');
        },
        set: function (value) {
            this._setOption('customizeHint', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "customizeText", {
        get: function () {
            return this._getOption('customizeText');
        },
        set: function (value) {
            this._setOption('customizeText', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "font", {
        get: function () {
            return this._getOption('font');
        },
        set: function (value) {
            this._setOption('font', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "horizontalAlignment", {
        get: function () {
            return this._getOption('horizontalAlignment');
        },
        set: function (value) {
            this._setOption('horizontalAlignment', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "itemsAlignment", {
        get: function () {
            return this._getOption('itemsAlignment');
        },
        set: function (value) {
            this._setOption('itemsAlignment', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "itemTextPosition", {
        get: function () {
            return this._getOption('itemTextPosition');
        },
        set: function (value) {
            this._setOption('itemTextPosition', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "margin", {
        get: function () {
            return this._getOption('margin');
        },
        set: function (value) {
            this._setOption('margin', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "markerColor", {
        get: function () {
            return this._getOption('markerColor');
        },
        set: function (value) {
            this._setOption('markerColor', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "markerShape", {
        get: function () {
            return this._getOption('markerShape');
        },
        set: function (value) {
            this._setOption('markerShape', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "markerSize", {
        get: function () {
            return this._getOption('markerSize');
        },
        set: function (value) {
            this._setOption('markerSize', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "orientation", {
        get: function () {
            return this._getOption('orientation');
        },
        set: function (value) {
            this._setOption('orientation', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "paddingLeftRight", {
        get: function () {
            return this._getOption('paddingLeftRight');
        },
        set: function (value) {
            this._setOption('paddingLeftRight', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "paddingTopBottom", {
        get: function () {
            return this._getOption('paddingTopBottom');
        },
        set: function (value) {
            this._setOption('paddingTopBottom', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "rowCount", {
        get: function () {
            return this._getOption('rowCount');
        },
        set: function (value) {
            this._setOption('rowCount', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "rowItemSpacing", {
        get: function () {
            return this._getOption('rowItemSpacing');
        },
        set: function (value) {
            this._setOption('rowItemSpacing', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "source", {
        get: function () {
            return this._getOption('source');
        },
        set: function (value) {
            this._setOption('source', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "verticalAlignment", {
        get: function () {
            return this._getOption('verticalAlignment');
        },
        set: function (value) {
            this._setOption('verticalAlignment', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "visible", {
        get: function () {
            return this._getOption('visible');
        },
        set: function (value) {
            this._setOption('visible', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxiLegendComponent.prototype, "_optionPath", {
        get: function () {
            return 'legends';
        },
        enumerable: true,
        configurable: true
    });
    DxiLegendComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'dxi-legend',
                    template: '',
                    styles: [''],
                    providers: [nested_option_1.NestedOptionHost]
                },] },
    ];
    DxiLegendComponent.ctorParameters = function () { return [
        { type: nested_option_1.NestedOptionHost, decorators: [{ type: core_1.SkipSelf }, { type: core_1.Host },] },
        { type: nested_option_1.NestedOptionHost, decorators: [{ type: core_1.Host },] },
    ]; };
    DxiLegendComponent.propDecorators = {
        'backgroundColor': [{ type: core_1.Input },],
        'border': [{ type: core_1.Input },],
        'columnCount': [{ type: core_1.Input },],
        'columnItemSpacing': [{ type: core_1.Input },],
        'customizeHint': [{ type: core_1.Input },],
        'customizeText': [{ type: core_1.Input },],
        'font': [{ type: core_1.Input },],
        'horizontalAlignment': [{ type: core_1.Input },],
        'itemsAlignment': [{ type: core_1.Input },],
        'itemTextPosition': [{ type: core_1.Input },],
        'margin': [{ type: core_1.Input },],
        'markerColor': [{ type: core_1.Input },],
        'markerShape': [{ type: core_1.Input },],
        'markerSize': [{ type: core_1.Input },],
        'orientation': [{ type: core_1.Input },],
        'paddingLeftRight': [{ type: core_1.Input },],
        'paddingTopBottom': [{ type: core_1.Input },],
        'rowCount': [{ type: core_1.Input },],
        'rowItemSpacing': [{ type: core_1.Input },],
        'source': [{ type: core_1.Input },],
        'verticalAlignment': [{ type: core_1.Input },],
        'visible': [{ type: core_1.Input },],
    };
    return DxiLegendComponent;
}(nested_option_2.CollectionNestedOption));
exports.DxiLegendComponent = DxiLegendComponent;
var DxiLegendModule = (function () {
    function DxiLegendModule() {
    }
    DxiLegendModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [
                        DxiLegendComponent
                    ],
                    exports: [
                        DxiLegendComponent
                    ],
                },] },
    ];
    DxiLegendModule.ctorParameters = function () { return []; };
    return DxiLegendModule;
}());
exports.DxiLegendModule = DxiLegendModule;
//# sourceMappingURL=legend-dxi.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/devextreme-angular/ui/nested/legend-dxi.js
// module id = ../../../../devextreme-angular/ui/nested/legend-dxi.js
// module chunks = 3